<template>
  <a-result status="404" title="404" sub-title="抱歉，您访问的页面不存在">
    <template #extra>
      <a-button v-on:click="onClickFeedback" type="link">
        反馈
      </a-button>
      <a-button v-on:click="onClickBack" type="primary">
        返回主页
      </a-button>
    </template>
  </a-result>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    onClickBack() {
      this.$router.push({ path: '/' });
    },
    onClickFeedback() {
      this.$router.push({ path: '/feedback' });
    }
  }
};
</script>
